import React, { FunctionComponent } from "react";
import { NodeProps } from "reactflow";
import { BasicNodeLayout, NodeSize, NodeType, NodeTypeCategory } from "../Base";
import { DataType } from "../TypeDefinitions";
import { ComparisonLabel } from "./ComparisonLabel";

globalThis.nodeTypeDefinitions.setDefinition({
  nodeType: NodeType.greaterThanNumber,
  category: NodeTypeCategory.logic,
  isExperimental: true,
  controlOutputs: [],
  dataInputs: [
    { name: "left", type: DataType.DECIMAL, hideLabel: true },
    { name: "right", type: DataType.DECIMAL, hideLabel: true }
  ],
  dataOutputs: [{ name: "result", type: DataType.BOOLEAN }],
  size: NodeSize.Small,
  evaluate: (input: any) => {
    return {
      output: { result: input.left >= input.right },
      activeControlHandleIds: []
    };
  }
});

export const GreaterThanNumberNode: FunctionComponent<NodeProps> = ({ id, data }) => {
  return (
    <BasicNodeLayout id={id} data={data}>
      <ComparisonLabel nodeId={id} comparisonOperator="GreaterOrEqual" />
    </BasicNodeLayout>
  );
};
